module.exports = __webpack_public_path__ + "./Verna_333eca87974f58d0081f8ac27c48efb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Verna.jpg
// module id = 578
// module chunks = 0